export const getSwatchFilterItemValues = (item: string) => {
  const values = item?.split(' | ');

  return {
    name: values?.[0],
    code: values?.[1],
  };
};
